import React, { useEffect, useRef, useState } from 'react'
import { Dropdown } from 'primereact/dropdown'
import _ from 'lodash'

export default function LtsDropdownIdValue(props) {
  const [options, setOptions] = useState([])
  // so a resposta do pedido mais recente vale: trocado o parametro (ex.: a unidade) antes de a carga anterior
  // voltar, a resposta antiga chegando por ultimo trocaria as opcoes pelas do parametro velho
  const ultimoPedido = useRef(0)

  // com loadDataFn as opcoes vem dela: um options recriado a cada render da tela (mapStateToProps) nao recarrega, senao
  // cada render invalidaria a carga em andamento e o campo ficaria vazio enquanto o usuario digita em outro
  const optionsUsadas = props.forceOptions || !props.loadDataFn ? props.options : null
  useEffect(() => {
    loadData()
  }, [props.loadDataFnParam, optionsUsadas])

  useEffect(
    () => () => {
      ultimoPedido.current++
    },
    []
  )

  const loadData = () => {
    const pedido = ++ultimoPedido.current
    const seVigente = (fn) => (resultado) => pedido === ultimoPedido.current ? fn(resultado) : undefined
    const forceOptions = _.get(props, 'forceOptions', false)
    if (forceOptions) {
      setOptions(_.get(props, 'options', []))
      return
    }
    const loadDataFn = _.get(props, 'loadDataFn', null)
    if (loadDataFn) {
      if (props.hasOwnProperty('loadDataFnParam')) {
        loadDataFn
          .call(loadDataFn, props.loadDataFnParam)
          .then(seVigente(onSuccessLoadData))
          .catch(seVigente(onErrorLoadData))
      } else {
        loadDataFn.call(loadDataFn).then(seVigente(onSuccessLoadData)).catch(seVigente(onErrorLoadData))
      }
    } else {
      const options_ = _.get(props, 'options', [])
      if (options_.length > 0) {
        const showOptionAll = _.get(props, 'showOptionAll', false)
        if (showOptionAll) {
          const clonedArray = JSON.parse(JSON.stringify(options_))
          clonedArray.unshift({ id: 0, value: 'Todos' })
          setOptions(clonedArray)
        } else {
          setOptions(options_)
        }
      }
    }
  }

  const onSuccessLoadData = (response) => {
    const data = _.get(response, 'data', [])
    const showOptionAll = _.get(props, 'showOptionAll', false)
    if (showOptionAll) {
      data.unshift({ id: 0, value: 'Todos' })
    }

    const sorted = _.sortBy(data, 'value')

    // hook para componentes que usam internamente esse componente possam
    // manipular os dados antes de serem renderizados
    if (props.hasOwnProperty('afterLoadDataFn')) {
      setOptions(props.afterLoadDataFn(sorted))
    } else {
      setOptions(sorted)
    }
  }

  const onErrorLoadData = (error) => {
    console.log(error)
  }

  const onChange = (e) => {
    props.onChange(e.value)
  }

  const resolveName = () => {
    return props.name
  }

  const resolveLabel = () => {
    if (props.label) {
      return <label>{props.label}</label>
    }
    return null
  }

  const resolveValue = (value) => {
    if (props.hasOwnProperty('resolveValueFn')) {
      return props.resolveValueFn(value)
    }
    return value
  }

  return (
    <React.Fragment>
      <span className="p-float-label">
        <Dropdown
          value={resolveValue(props.value)}
          options={options}
          onChange={onChange}
          optionLabel={props.optionLabel || 'value'}
          optionValue={props.optionValue || ((v) => v)}
          dataKey={props.dataKey || 'value'}
          name={resolveName()}
          disabled={props.disabled}
          itemTemplate={props.itemTemplate}
          style={props.style}
        />
        {resolveLabel()}
      </span>
    </React.Fragment>
  )
}
